import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import { withRadium, gtmEvent } from "higher-order-components"
import { AnimatedPlusMinus } from "containers"
import { GlobalNavLink, Hyperlink } from "components"
import { gtmGlobalNavActionTypes } from "store/gtm-events"

/* Navigation Dropdown Component. */
class GlobalNavLinkAccordion extends PureComponent {
  constructor() {
    super()
    this.state = {
      contentHeight: 0
    }
    this.getHeight = this.getHeight.bind(this)
  }
  componentDidMount() {
    this.getHeight()
  }
  componentDidUpdate() {
    this.getHeight()
  }
  getHeight() {
    if (this.contentEl) this.setState({ contentHeight: this.contentEl.offsetHeight + 32 })
  }
  /**
   * @param {String} label - Navigation Label
   * @param {Array|Overlay} components - Nested Components.
   * @returns {ReactElement} React Component
   */
  render() {
    return (
      <div
        data-test="nav-accordion"
        style={[styles.base, this.props.subNav ? subNav.base : topNav.base]}>
        <GlobalNavLink
          type="span"
          onClick={this.props.toggleActive}
          label={this.props.label}
          subNav={this.props.subNav}
          active={this.props.active}
          gtm={this.props.gtm}>
          {this.props.subNav ? (
            <div style={subNav.iconPos}>
              <AnimatedPlusMinus open={this.props.active} />
            </div>
          ) : (
              ""
            )}
        </GlobalNavLink>
        <div
          style={{
            height: this.props.active ? `${this.state.contentHeight}px` : "0px",
            overflow: "hidden",
            transition: ".25s"
          }}>
          <div
            ref={(c) => {
              this.contentEl = c
            }}
            style={{ boxSizing: "border-box" }}>
            <ol style={styles.ol}>
              {this.props.components[0].props.components[0].props.components.map((component, index) => (
                <li style={styles.li} key={index}>
                  <Hyperlink
                    href={component.props.href}
                    style={styles.a}
                    key={index}
                    withoutStyle
                    gtmEvents={[
                      {
                        func: this.props.gtmEvent,
                        args: {
                          gtmID: gtmGlobalNavActionTypes.NAV_LINK_SECONDARY_CLICK,
                          gtmPayload: {
                            CMSGroupGTM: component.props.gtm
                          }
                        }
                      }
                    ]} >
                    {component.props.name}
                  </Hyperlink>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    )
  }
}

GlobalNavLinkAccordion.propTypes = {
  label: PropTypes.string.isRequired,
  components: PropTypes.array.isRequired,
  toggleActive: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
  subNav: PropTypes.bool,
  close: PropTypes.func
}

export default withRadium(gtmEvent())(GlobalNavLinkAccordion)

const styles = {
  base: {
    textTransform: "uppercase",
    cursor: "pointer",
    transition: ".25s",
    position: "relative",
    padding: "1px 0",
    "@media (min-width: 900px)": {
      position: "static"
    }
  },
  ol: {
    listStyle: "none",
    padding: "1.5em 2.15em",
    background: "#ffffff",
    textTransform: "capitalize",
    marginBottom: "1.5em",
    boxSizing: "border-box",
    "@media (min-width: 768px)": {
      padding: "1.5em 4em"
    }
  },
  li: {
    fontSize: "90%"
  },
  a: {
    textDecoration: "none",
    padding: ".75em 0",
    display: "block",
    color: "#999999",
    ":hover": {
      color: "#101010",
      transition: ".2s ease-in-out"
    }
  }
}

const topNav = {
  base: {
    display: "inline-block"
  }
}

const subNav = {
  base: {
    display: "block",
    color: "#808080",
    margin: "auto",
    flex: "1 1 100%"
  },
  iconPos: {
    position: "absolute",
    right: "1.25em",
    top: ".7em",
    width: "1em",
    height: "1em",
    "@media (min-width: 768px)": {
      top: ".375em"
    },
    "@media (min-width: 900px)": {
      display: "none"
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/global-nav-link-accordion/index.jsx